// ## ClientAuthZFsm
//
// State machine for AuthZ status of Client (Flash/HTML5) Auth.

'use strict';

var _ = require('./vendor/underscore');
var machina = require('./vendor/machina');
var _logger = require('./logger');


var ClientAuthZFsm = machina.Fsm.extend({

	initialize : function () {

		_.bindAll(this, 'checkAuthZ');

		this.on('handling', function (data) {
			_logger.debug('[ClientAuthZFsm:' + this.state + '] handling ' + data.inputType, arguments);
		});
		this.on('handled', function (data) {
			_logger.debug('[ClientAuthZFsm:' + this.state + '] handled ' + data.inputType, arguments);
		});
		this.on('nohandler', function (data) {
			_logger.debug('[ClientAuthZFsm:' + this.state + '] nohandler', data.inputType, arguments);
		});
		this.on('transition', function (data) {
			_logger.debug('[ClientAuthZFsm:' + this.state + '] transition from "' + data.fromState + '" to "' + data.toState + '" via "' + data.action + '"', arguments);
		});
		this.on('invalidstate', function () {
			_logger.debug('[ClientAuthZFsm:' + this.state + '] invalidstate', arguments);
		});
		this.on('deferred', function () {
			_logger.debug('[ClientAuthZFsm:' + this.state + '] deferred', arguments);
		});

	},

	constraints : {
		'Authorizing' : {
			nextState : 'Ready',
			checkList : {
				hasErrorEvent : false,
				hasFlowEvent : false
			}
		}
	},

	resetConstraints : function () {
		var state = this.state;
		switch (state) {
			case 'Authorizing':
				_logger.debug('[ClientAuthZFsm:' + state + '] resetting constraints for state "' + state + '"');
				_.each(this.constraints[state].checkList, function (constraint, i, list) {
					list[i] = false;
				});
			break;
			default:
				_logger.debug('[ClientAuthZFsm:' + this.state + '] no constraints to reset for state "' + state + '"');
		}
	},

	proceedIfAllConstraintsAreMet : function () {
		var state = this.state;
		var constraints = this.constraints[state];
		if (!constraints) {
			_logger.debug('[ClientAuthZFsm:' + state + '] no constraints for state "' + state + '"');
			return;
		}
		if (_.all(constraints.checkList, _.identity)) {
			this.transition(constraints.nextState);
		}
	},

	initialState : 'Offline',

	states : {

		'Offline' : {

			'ready' : 'Ready'

		},

		'Ready' : {

			'checkAuthZ' : function (resourceId, feature) {
				this.resourceId = resourceId;
				this.feature = feature;
				this.transition('Authorizing');
				this.authManager._checkAuthZ(resourceId, feature);
			}

		},

		'Authorizing' : {

			_onEnter : function () {
				this.resetConstraints();
			},

			'authZPass' : function (obj) {
				_logger.debug('Received authz success flow event');
				this.emit('authZPass', obj);
				this.transition('Ready');
			},

			'authZFail' : function () {
				_logger.debug('Received authz failure flow event');
				this.constraints[this.state].checkList.hasFlowEvent = true;
				this.proceedIfAllConstraintsAreMet();
			},

			'error' : function (obj) {
				_logger.debug('Received authz failure error event');
				this._error = obj;
				this.constraints[this.state].checkList.hasErrorEvent = true;
				this.proceedIfAllConstraintsAreMet();
			},

			_onExit : function () {
				if (this._error) {
					this.emit('authZFail', this._error);
					this._error = null;
				}
			}

		}

	},

	checkAuthZ : function (resourceId, feature) {
		if (!arguments.length) {
			resourceId = this.resourceId;
			feature = this.feature;
		}

		this.handle('checkAuthZ', resourceId, feature);
	},

	handleInitReady : function () {
		this.handle('ready');
	},

	handleAuthZPass : function (obj) {
		this.handle('authZPass', obj);
	},

	handleAuthZFail : function (obj) {
		this.handle('authZFail', obj);
	},

	ignoredErrorCodes : [  // errors that aren't failures
		'N001',  // authenticated passively
		// 'N005',  // authentication cancelled
		'N010',  // authenticated while in degradation
		'N011',  // authenticated with TempPass
		'N120',  // multiple authN calls (not exactly an authNFail)
		'Z010',  // authorized while in degradation
		'Z011',  // authZ with TempPass
		'CFG100'  // correct clock
	],

	handleAuthError : function (obj) {
		var errData = obj.data;
		var errorId = errData.errorId;
		if (_.contains(this.ignoredErrorCodes, errorId)) {
			_logger.debug('Ignoring authZ error ' + errorId);
		}
		else {
			this.authManager.getProviderID(function getProviderIDResponse(providerId) {
				var data = {};
				data.mvpdId = providerId;
				data.resource = this.resourceId;
				data.errorCode = errData.errorCode || errData.errorId;

				if (errData.message) {
					data.errorString = errData.message;
				}

				if (errData.messageHtml) {
					data.errorHtml = errData.messageHtml;
				}

				if (errData.errorCategory) {
					data.errorCategory = errData.errorCategory;
				}

				if (errData.resolution) {
					data.resolution = errData.resolution;
				}

				this.handle('error', data);
			}, this);
		}
	},

	init : function (AuthManager) {
		if (!AuthManager) {
			throw new Error('AuthManager required for init!');
		}

		this.authManager = AuthManager;

		this.authManager.on('initReady', this.handleInitReady, this);
		this.authManager.on('error', this.handleAuthError, this);
	}

});


module.exports = ClientAuthZFsm;
